import { MainLayout } from "layouts";
import ArticleDetails from "pages/ArticleDetails";
import BannerDetails from "pages/BannerDetails";
import Error404 from "pages/Error404";
import Gallery from "pages/Gallery";
import Home from "pages/Home";
import PersonDetails from "pages/PersonDetails";
import Privacy from "pages/Privacy";
import ProductDetails from "pages/ProductDetails";
import RedirectHandler from "pages/RedirectHandler";
import Terms from "pages/Terms";

const routes = [
  {
    path: "",
    element: <Home />,
  },
  {
    path: "/:userId",
    element: <MainLayout />,
    children: [
      { path: "", element: <PersonDetails /> },
      { path: "gallery", element: <Gallery /> },
      { path: "product-details", element: <ProductDetails /> },
      { path: "article-details", element: <ArticleDetails /> },
      { path: "banner-details", element: <BannerDetails /> },
    ],
  },
  {
    path: "/:type/:userId",
    element: <RedirectHandler />,
  },
  { path: "/terms", element: <Terms /> },
  { path: "/privacy", element: <Privacy /> },
  { path: "*", element: <Error404 /> },
];

export default routes;
